import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

function getTwoLineAddress(row: FulfillmentGroupData) {
  const address = row.verifiedDestinationAddress || row.destinationAddress;
  const line1 = [address?.address1, address?.address2]
    .filter(Boolean)
    .join(" ");
  const cityState = [address?.city, address?.province]
    .filter(Boolean)
    .join(", ");
  const line2 = [cityState, address?.zip].filter(Boolean).join(" ");

  return [line1, line2];
}

export const StreetAddressCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Street address",
    cell: (row) => {
      const [line1, line2] = getTwoLineAddress(row);

      return [line1, line2].filter(Boolean).join(", ");
    },
  };
